import { useRef, useState } from "react";

interface TvCarouselProps {
  children: React.ReactNode;
  className?: string;
}

export default function TvCarousel({ children, className = "" }: TvCarouselProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);

  const updateArrows = () => {
    const el = containerRef.current;
    if (!el) return;
    setShowLeft(el.scrollLeft > 10);
    setShowRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 10);
  };

  const scroll = (direction: "left" | "right") => {
    const el = containerRef.current;
    if (!el) return;
    const scrollAmount = el.clientWidth * 0.75;
    el.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
    setTimeout(updateArrows, 350);
  };

  const handleKeyDown = (e: React.KeyboardEvent, direction: "left" | "right") => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      scroll(direction);
    }
  };

  return (
    <div className={`relative group ${className}`}>
      {/* Left arrow */}
      {showLeft && (
        <button
          tabIndex={0}
          onClick={() => scroll("left")}
          onKeyDown={(e) => handleKeyDown(e, "left")}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-[#0a0a0f]/80 backdrop-blur-sm border border-white/10 text-white flex items-center justify-center cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity outline-none focus:ring-2 focus:ring-white focus:opacity-100"
          aria-label="Desplazar izquierda"
        >
          <i className="ri-arrow-left-s-line text-lg"></i>
        </button>
      )}

      {/* Scrollable container */}
      <div
        ref={containerRef}
        className="flex gap-4 overflow-x-auto pb-2"
        style={{ scrollSnapType: "x mandatory", scrollbarWidth: "none" }}
        onScroll={updateArrows}
      >
        {children}
      </div>

      {/* Right arrow */}
      {showRight && (
        <button
          tabIndex={0}
          onClick={() => scroll("right")}
          onKeyDown={(e) => handleKeyDown(e, "right")}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-[#0a0a0f]/80 backdrop-blur-sm border border-white/10 text-white flex items-center justify-center cursor-pointer opacity-0 group-hover:opacity-100 transition-opacity outline-none focus:ring-2 focus:ring-white focus:opacity-100"
          aria-label="Desplazar derecha"
        >
          <i className="ri-arrow-right-s-line text-lg"></i>
        </button>
      )}
    </div>
  );
}